// Banner slider'larında parmakla sağa/sola kaydırma jesti.
//
// Karar bilinçli olarak saf bir fonksiyonda durur: hook (hooks/useSwipe.js)
// yalnızca dokunma olaylarının koordinatlarını buraya taşır, eşikler tek
// yerde yaşar ve dört tema aynı hissi verir.

// Kaydırma sayılması için gereken en küçük yatay mesafe (piksel). Daha
// küçüğü dokunmanın kendi titremesidir; banner'ı çevirmemelidir.
export const SWIPE_MIN_DISTANCE = 45;

// Yatay kayma dikeyin en az bu katı olmalıdır. Oran aranmazsa sayfayı dikey
// kaydıran parmağın yana sapması banner'ı çevirir ve oyuncu ne olduğunu
// anlamadan slayt kaybeder.
export const SWIPE_RATIO = 1.2;

/**
 * İki dokunma noktasından kaydırma yönünü çözer.
 *
 * @param {{x: number, y: number}|null} start parmağın indiği nokta
 * @param {{x: number, y: number}|null} end parmağın kalktığı nokta
 * @returns {'left'|'right'|null} 'left' sonraki, 'right' önceki slayt;
 *   jest kaydırma sayılmazsa null.
 */
export function resolveSwipe(start, end, options = {}) {
  const { minDistance = SWIPE_MIN_DISTANCE, ratio = SWIPE_RATIO } = options;
  if (!start || !end) return null;

  const dx = end.x - start.x;
  const dy = end.y - start.y;
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return null;

  const absX = Math.abs(dx);
  const absY = Math.abs(dy);
  if (absX < minDistance) return null;
  if (absX < absY * ratio) return null;

  return dx < 0 ? 'left' : 'right';
}

export default resolveSwipe;
